import { Component, OnInit, OnDestroy, ChangeDetectorRef, Input, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, NgForm, Validators } from "@angular/forms";
import { Subscription, Observable, BehaviorSubject, Subject, combineLatest } from "rxjs";
import { filter, first, map, takeUntil } from "rxjs/operators";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticatedResponse } from "src/app/shared/models/AuthenticatedResponse";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { FormrulesConfigService } from "src/app/shared/configuration/formrules-config.service";
import { AlertService } from "src/app/alerts/alert.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { SessionUser } from "src/app/shared/models/sessionUser";
import { MsalBroadcastService, MsalService } from "@azure/msal-angular";
import { AuthenticationResult, EventMessage, EventType, InteractionStatus } from "@azure/msal-browser";
import { PermissionService } from "src/app/services/permission.service";
import Swal from "sweetalert2";
import { FacturacionIndividualService } from "src/app/services/facturacion-individual.service";
import { CodigosAduana } from "src/app/models/Dte/Exportacion/CodigosAduana";
import { UsuarioService } from "src/app/services/usuario.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { NotificationService } from "src/app/services/notification.service";
import { AuthService } from "../../_services/auth.service";
import { AuthConfigService } from "../../_services/auth-config.service";
import { UserModel } from "../../_models/user.model";

@Component({
	selector: "app-login-demo",
	templateUrl: "./login-demo.component.html",
	styleUrls: ["./login-demo.component.scss"],
})
export class LoginComponentDemo implements OnInit, OnDestroy {
	@ViewChild("currentSwal") private currentSwal: SwalComponent;
	// KeenThemes mock, change it to:
	defaultAuth = {
		email: "demo@chilesystems.com",
		password: "",
	};
	// defaultAuth: any = {
	//   email: 'admin@demo.com',
	//   password: 'demo',
	// };
	loginForm: FormGroup;
	requestPasswordForm: FormGroup;
	requestPasswordModal: NgbModalRef;
	hasError: boolean = false;
	returnUrl: string;
	isLoading$: Observable<boolean>;
	retryCounter: number; //el retryCounter gatilla el metodo de bloqueo (y envio correo)
	localIPAddress: string; //obtener ip de maquina con api.ipify.org
	loginErrorMessage: string = "Ha ocurrido un error en la operación";
	passwordIsTemporal: boolean = false;
	public loading: boolean = false;
	loginDisplay = false;
	private readonly _destroying$ = new Subject<void>();
	private isLoadingCodigosAduana$: Observable<boolean>;
	public isLoadingRecover$: Observable<boolean>;
	// private fields
	private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
	constructor(
		private fb: FormBuilder,
		private authService: AuthService,
		private tokenStorage: TokenStorageService,
		private authConfig: AuthConfigService,
		private formConfig: FormrulesConfigService,
		private route: ActivatedRoute,
		private router: Router,
		private utilities: UtilitiesService,
		private modalService: NgbModal,
		private alertService: AlertService,
		private localStorage: LocalStorageService,
		private msalBroadcastService: MsalBroadcastService,
		private msalService: MsalService,
		private permissions: PermissionService,
		private facturador: FacturacionIndividualService,
		private usuarioService: UsuarioService,
		private ref: ChangeDetectorRef,
		private notificationService: NotificationService
	) {
		this.isLoading$ = this.authService.isLoading$;
		this.isLoadingCodigosAduana$ = this.facturador.isLoadingCodigosAduana;
		this.isLoadingRecover$ = this.authService.isLoadingRecoverPassword$;
		// redirect to home if already logged in
		// if (this.authService.currentUserValue) {
		//   this.router.navigate(["/"]);
		// }
	}

	get combinedObs$() {
		return combineLatest([this.isLoading$, this.isLoadingCodigosAduana$]).pipe(
			map((loginRes) => {
				return loginRes[0] || loginRes[1];
			})
		);
	}

	ngOnInit(): void {
		const session = this.localStorage.getUserSession();
		if (session && session.estado === true) {
			this.authService.logout().subscribe(
				(response) => {
				console.log("Sesión cerrada con éxito al iniciar la app", response);
				},
				(error) => {
				console.error("Error cerrando sesión al iniciar la app", error);
				}
			);
		}

		this.initForm();
		this.loginForm.reset();
		// get return url from route parameters or default to '/'
		this.returnUrl = this.route.snapshot.queryParams["returnUrl".toString()] || "/";
		this.initRequestPasswordForm();
		this.retryCounter = 0;
		if (this.tokenStorage.getToken()) {
			this.router.navigate(['/']);
			return;
		}
		this.f.email.setValue("demo@chilesystems.com");
		this.f.password.setValue("Rv8Il4eV");
		this.msalBroadcastService.inProgress$
			.pipe(
				filter((status: InteractionStatus) => status === InteractionStatus.None),
				takeUntil(this._destroying$)
			)
			.subscribe(() => {
				this.setLoginDisplay();
			});

		this.msalBroadcastService.msalSubject$.pipe(filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS)).subscribe((result: EventMessage) => {
			const payload = result.payload as AuthenticationResult;
			this.msalService.instance.setActiveAccount(payload.account);
			this.tokenStorage.setMsalUser();
			this.tokenStorage.msalUserHasLogged();
			this.router.navigate(["/"]);
		});
	}

	setLoginDisplay() {
		this.loginDisplay = this.msalService.instance.getAllAccounts().length > 0;
	}

	externalLogin() {
		this.tokenStorage.msalLogin();
	}

	// convenience getter for easy access to form fields
	get f() {
		return this.loginForm.controls;
	}

	get g() {
		return this.requestPasswordForm.controls;
	}

	initForm() {
		this.loginForm = this.fb.group({
			email: [
				"",
				Validators.compose([
					Validators.required,
					Validators.email,
					Validators.pattern(this.formConfig.emailPatternRegex),
					Validators.minLength(3),
					Validators.maxLength(320), // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
				]),
			],
			password: ["", Validators.compose([Validators.required, Validators.minLength(this.formConfig.passwordMinLength), Validators.maxLength(this.formConfig.passwordMaxLength), Validators.pattern(this.formConfig.passwordPatternRegex)])],
		});
	}

	initRequestPasswordForm() {
		this.requestPasswordForm = this.fb.group({
			email: ["", [Validators.required, Validators.email, Validators.pattern(this.formConfig.emailPatternRegex), Validators.minLength(3), Validators.maxLength(320)]],
		});
	}

	tryLogin() {
		this.hasError = false;
		this.loading = true;
		const loginSubscription = this.authService
			.tokenLogin(this.f.email.value, this.f.password.value)
			.subscribe(
				(result) => {
					this.loading = false;
					let authResponse = result as AuthenticatedResponse;
					this.tokenStorage.saveToken(authResponse.token);
					this.tokenStorage.saveUserData(authResponse);
					this.localStorage.saveUserSession(authResponse.userSession);
					this.localStorage.saveDteTypes(authResponse.tipoDte);
					this.localStorage.saveEmisores(authResponse.emisores);
					this.localStorage.saveSucursales(authResponse.sucursales);
					this.localStorage.saveOrigenImportaciones(authResponse.origenImportaciones);
					this.localStorage.saveEstadosDteRecibidos(authResponse.estadoDteRecibidos);
					this.localStorage.saveTipoAcuseRecibo(authResponse.tiposAcuseRecibo);
					this.localStorage.saveTipoDocReferencias(authResponse.tipoDocumentoReferencias);
					this.localStorage.saveRespuestaEstadoDte(authResponse.respuestaEstadoDte);
					this.localStorage.saveTipoImpuestos(authResponse.tipoImpuestos);
					this.permissions.savePermissionList(authResponse.permisos);
					this.localStorage.saveImpuestos(authResponse.impuestos);
					this.localStorage.saveTipoRetenciones(authResponse.retenciones);
					this.localStorage.saveFacturables(authResponse.facturables);
					this.localStorage.saveTipoComisiones(authResponse.tipoComisiones);
					this.localStorage.saveTipoTraslados(authResponse.tipoTraslados);
					this.localStorage.saveTipoDespacho(authResponse.tipoDespacho);
					this.localStorage.saveActividadesEconomicas(authResponse.actividadesEconomicas);
					this.localStorage.saveCasillaCorreoDteRecibidos(authResponse.casillaDteRecibidos);
					this.localStorage.saveMonedaAduanas(authResponse.monedaAduanas);
					this.localStorage.saveTipoAmbiente(authResponse.ambientes);
					this.localStorage.saveTipoCorreoEnvio(authResponse.tiposEnvioCorreo);
					this.localStorage.saveTipoPlantillaoCorreoEnvio(authResponse.tiposPlantillaEnvioCorreo);
					this.localStorage.saveListaUsuarios(authResponse.usuarios);
					this.localStorage.saveEstadosSii(authResponse.estadosSii);
					this.localStorage.saveEstadoAcuseEmitidos(authResponse.estadosAcuseEmitidos);
					this.permissions.isSuperAdmin = authResponse.superAdmin;
					this.permissions.loadRoutePermissions();
					let userFullName = new UserModel();
					userFullName.fullname = authResponse.firstName + " " + authResponse.lastName;
					//seccion de codigos aduana
					this.loading = true;
					this.facturador.getCodigosAduana().subscribe(
						(res) => {
							let codigos: CodigosAduana = res.data;
							codigos.unidadMedidas.forEach((unidad) => {
								unidad.nombreSigla = unidad.codigoArancelario + " - " + unidad.nombreUnidadMedida;
							});
							this.localStorage.saveCodigosAduana(codigos);
							this.loading = false;
							this.ref.detectChanges();

							//login continua tras recibir datos de codigos
							let currentPerm = this.permissions.getAccessPermission();
							if (!currentPerm || !currentPerm.asignado) {
								// this.toErrorSwal(this.currentSwal,"Acceso Denegado","Su perfil no tiene acceso a la plataforma. Favor contacte a su administrador.")
								// this.currentSwal.fire();
							}
							if (this.tokenStorage.getToken() && this.tokenStorage.getUser()) {
								//this.router.navigate([this.returnUrl]);
								let userSaved = this.tokenStorage.getUser();
								this.passwordIsTemporal = userSaved.temporaryPassword;
								if (this.passwordIsTemporal) {
									//this.navigateToChangePassword();
									this.router.navigate(["/auth/change-password"]);
								} else {
									this.navigateToMain();
									this.notificationService.checkNotifications();
								}
							} else {
								this.hasError = true;
							}
						},
						(error) => {
							this.loading = false;
							this.ref.detectChanges();
							Swal.fire({
								icon: "error",
								title: "Error en Codigos",
								text: "No fue posible obtener los códigos de aduanas para emitir una factura de exportación,recargue la pagina e intene nuevamente",
							});
						}
					);
				},
				(error) => {
					this.loading = false;
					this.errorResponseCounter(error.error);
					this.hasError = true;
					this.loginErrorMessage = this.utilities.setLoginErrorMessageFromArray(error.error);
					//"No se pudo conectar con el servicio. " + "Ingrese las credenciales correctas."
					// "Intentos disponibles: " +
					// (this.authConfig.loginRetries - this.retryCounter > 0
					//   ? this.authConfig.loginRetries - this.retryCounter
					//   : 0);

					this.alertService.error("Texto prueba", {
						id: "alert-general",
						autoClose: "true",
					});
					//this.tokenStorage.saveToken("AA","AAA");
					//this.router.navigate([this.returnUrl]);
				}
			)
			.add(() => {
				// this.authService.tokenList().subscribe(
				//   (result) => {
				//     this.loading = false;
				//   },
				//   (error) => {
				//     this.loading = false;
				//   }
				// );
			});
		//this.unsubscribe.push(loginSubscription);
	}

	openRequestPasswordModal(modalRef) {
		this.requestPasswordModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
		});
	}

	private navigateToMain() {
		//this.router.navigate([this.returnUrl]);
		this.router.navigate(["/"]);
	}

	errorResponseCounter(error: any) {
		if (error) {
			this.retryCounter++;
			this.hasError = true;
			this.loginErrorMessage = "Las credenciales no son correctas." + "Intentos disponibles: " + (this.authConfig.loginRetries - this.retryCounter);
		}
		if (this.retryCounter >= this.authConfig.loginRetries) {
			const currentIP = this.authService.getIPAddress();
			const emailBlocked = this.f.email.value;
			if (currentIP && emailBlocked) {
				this.authService.blockAccount(emailBlocked, currentIP).subscribe(
					(result) => {
						this.hasError = true;
						this.loginErrorMessage = "La cuenta " + emailBlocked + " ha sobrepasado el límite de intentos de conexión y ha sido bloqueada desde la dirección IP: " + currentIP;
					},
					(error) => {}
				);
			}
		}
	}

	toSuccessSwal(swal: SwalComponent, titleString: string, textString: string) {
		swal.icon = "success";
		swal.title = titleString;
		swal.text = textString;
		swal.fire();
	}
	toErrorSwal(swal: SwalComponent, titleString: string, textString: string) {
		swal.icon = "error";
		swal.title = titleString;
		swal.text = textString;
		swal.fire();
	}
	ngOnDestroy() {
		this.unsubscribe.forEach((sb) => sb.unsubscribe());
	}
}
